import { BeachTypeId } from '../config/filterEnums';

export default function getBeachType(ids?: number[]): BeachTypeId | 0 {
    if (!ids) return 0;

    if (ids.includes(136)) return BeachTypeId.SandBeach;
    if (ids.includes(137)) return BeachTypeId.PebbleBeach;
    if (ids.includes(211)) return BeachTypeId.SandPebbleBeach;

    return 0;
}
